<template>
  <span>
    <a-form-item v-bind="_attrs" style="width: 100%">
      <a-popover placement="topLeft" slot="label" v-if="secondLanguage.length">
        <template slot="content">
          <div style="width: 200px">
            <a-row v-for="(item, index) in popLists" :key="index">
              <a-col :span="8" style="text-align: right; font-weight: bold">{{ item.langType }}：</a-col>
              <a-col :span="16">{{ item.langText }}</a-col>
            </a-row>
          </div>
        </template>
        <span>
          {{ langText }}
        </span>
      </a-popover>
      <span slot="label" v-else>
        {{ langText }}
      </span>
      <slot />
    </a-form-item>
  </span>
</template>

<script>
export default {
  name: 'mtcFormItem',
  data() {
    return {
      label: '',
      secondLanguage: JSON.parse(this.$ls.get('secondLanguage')) || []
    }
  },
  computed: {
    langText() {
      return this.$t(this.label) || this.label
    },
    _attrs() {
      this.attrs = { ...this.$attrs }
      this.label = this.attrs.label
      delete this.attrs[ 'label' ]
      return this.attrs
    },
    popLists() {
      let secondLanguage = JSON.parse(this.$ls.get('secondLanguage')) || []
      if (!this.label) return
      let secondLabel = secondLanguage.map(ele => {
        return {
          langType: ele,
          langText: this.$t(this.label, ele) || this.$t('tip.noData')
        }
      })
      return secondLabel
    }
  }
}
</script>

<style lang="less">
</style>